var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLisboa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lisboa",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lisboa_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.9,61.2V68h-5.4V27.1h-8.1v6.8H117v-6.8h-8.1v6.8h-5.4v-6.8h-8.1v40.8H90v-6.8h-8.1v49.8H76v-6.8h-8.1 v6.8h-5.4v-6.8h-8.1v6.8H51v-9.4c0-5.1-3.1-9.5-7.9-11.2v-5.4H35v5.4c-4.7,1.7-7.9,6.2-7.9,11.2v42.4h116.7V61.2H135.9z M35.2,111 v-9.5c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v9.5H35.2z M35.2,135.8v-16.7h46.5v16.7H35.2z M108.7,61.2V68h-5.4V42h19v26h-5.4 v-6.8H108.7z M135.9,119.1v16.7h-46v-16.7C89.8,119.1,135.9,119.1,135.9,119.1z M89.8,111V76h46v35H89.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 93,
    className: "st0",
    width: 8.1,
    height: 10.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 112.8,
    cy: 51.7,
    r: 5.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLisboa);
export default __webpack_public_path__ + "static/media/lisboa.2d09752b809ec83e4578a0346d3dfeb1.svg";
export { ForwardRef as ReactComponent };